import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PackageReception } from '../model/PackageReception';
import { RequestResponse } from '../model/dto/RequestResponse';

@Injectable()
export class PackageReceptionFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetAll(): Observable<RequestResponse<[PackageReception]>> {
        return this._httpClient.get<RequestResponse<[PackageReception]>>(this._urlBase + 'api/PackageReception/All');
    }

    Get(idStore): Observable<RequestResponse<[PackageReception]>> {
        return this._httpClient.get<RequestResponse<[PackageReception]>>(this._urlBase + 'api/PackageReception?idStore=' + idStore);
    }

    GetWithByStoreId(idStore): Observable<RequestResponse<[PackageReception]>> {
        return this._httpClient.get<RequestResponse<[PackageReception]>>(this._urlBase + 'api/PackageReception/GetWithAsnByStoreId?storeId=' + idStore);
    }

    GetById(idPackageReception): Observable<RequestResponse<PackageReception>> {
        return this._httpClient.get<RequestResponse<PackageReception>>(this._urlBase + 'api/PackageReception/' + idPackageReception);
    }

    GetWithASNById(idPackageReception): Observable<RequestResponse<PackageReception>> {
        return this._httpClient.get<RequestResponse<PackageReception>>(this._urlBase + 'api/PackageReception/GetWithASNById/' + idPackageReception);
    }
}
